class UtilFunctions {
  static transformCategories = (items) => {
    return items.map((category) => ({
      value: category.id,
      label: `${category.name} (ID: ${category.id})`,
      children:
        category.childCategories.length > 0
          ? this.transformCategories(category.childCategories)
          : null,
    }));
  };

  static formatDateTime = (timestamp) => {
    const dateObject = new Date(timestamp);
    return `${dateObject.toLocaleDateString(
      "en-US"
    )} ${dateObject.toLocaleTimeString("en-US")}`;
  };

  static transformData = (items) => {
    const groups = items.items.map((item) => {
      const criteria = {
        operator: "and",
        list: item.list.map((condition) => {
          let value = condition.value;
          if (
            (condition.key === "startedAt" || condition.key === "endedAt") &&
            value
          ) {
            value = value.toISOString();
          }
          return {
            key: condition.key,
            operation: condition.operation,
            value: value,
          };
        }),
      };
      console.log("criteria", criteria);
      return { criteria };
    });

    return {
      operator: "or",
      groups: [...groups],
    };
  };

  static filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  static formatDateToReadable(dateString) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("tr-TR", options);
  }

  static convertDecimalToColor = (decimalColor) => {
    if (decimalColor == null) return "rgba(0, 0, 0, 0)";
    const hexColor = Number(decimalColor).toString(16).padStart(8, "0");
    const alpha = hexColor.slice(0, 2);
    const red = hexColor.slice(2, 4);
    const green = hexColor.slice(4, 6);
    const blue = hexColor.slice(6, 8);
    const alphaDecimal = parseInt(alpha, 16) / 255;
    return `rgba(${parseInt(red, 16)}, ${parseInt(green, 16)}, ${parseInt(
      blue,
      16
    )}, ${alphaDecimal.toFixed(2)})`;
  };
}

export default UtilFunctions;
